module.exports = __webpack_public_path__ + "files/d1443680a5020c8609ddf0fd8ee5b685.png";